import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import DefaultLayout from "app/layouts/DefaultLayout";
import MainContentLayout from "app/layouts/MainContentLayout";
import LoadInitError from "app/components/commonUI/LoadInitError";
import LoadingProgress from "app/components/commonUI/LoadingProgress";
import NoData from "app/components/commonUI/NoData";

import { getAllVisitsToday } from "app/services/api";
import Path from "app/route/Path";
import TableVisit from "./TableVisit";

function CustomersUndergoingTreatment() {
  const [fetchToDayVisitState, setFetchCustomerBasicInfoState] = useState({
    isLoading: true,
    data: null,
    error: null,
  });
  const navigate = useNavigate();

  const loadToDayVisit = () => {
    setFetchCustomerBasicInfoState({
      isLoading: true,
      data: null,
      error: null,
    });

    getAllVisitsToday()
      .then((res) => {
        setFetchCustomerBasicInfoState({
          isLoading: false,
          data: res.data,
          error: null,
        });
      })
      .catch((error) => {
        setFetchCustomerBasicInfoState({
          isLoading: false,
          data: null,
          error: error,
        });
      });
  };

  useEffect(() => {
    loadToDayVisit();
  }, []);

  const handleClickRow = (visit) => {
    navigate(Path.duringService(visit.id));
  };

  return (
    <DefaultLayout>
      <MainContentLayout
        pageTitle={
          <>
            <p>お客様の</p>
            <p>お帰り</p>
          </>
        }
      >
        <div className="w-full h-full pt-16 pb-8 lg:py-12 relative">
          <div className="w-full h-16 lg:h-12 pl-20 lg:pl-0 flex items-center justify-start absolute inset-x-0 top-0 bg-[#F0F1EF] bg-opacity-50">
            <h2 className="text-base lg:text-xl font-semibold">施術中</h2>
          </div>

          <div className="w-full h-full py-3">
            <div className="w-full h-full pr-3 border border-gray-400 rounded-2xl p-4">
              <div className="w-full h-full overflow-auto">
                {fetchToDayVisitState.isLoading ? <LoadingProgress /> : null}

                {!fetchToDayVisitState.isLoading &&
                fetchToDayVisitState.error ? (
                  <LoadInitError error={fetchToDayVisitState.error} />
                ) : null}
                {!fetchToDayVisitState.isLoading &&
                !fetchToDayVisitState.error ? (
                  Array.isArray(fetchToDayVisitState.data) &&
                  fetchToDayVisitState.data.length > 0 ? (
                    <TableVisit
                      allVisit={fetchToDayVisitState.data}
                      handleClickRow={handleClickRow}
                    />
                  ) : (
                    <NoData />
                  )
                ) : null}
              </div>
            </div>
          </div>

          <div className="w-full h-8 flex items-center justify-end text-white text-base font-semibold absolute inset-x-0 bottom-0">
            <Link to={Path.home} className="button-size bg-gray-btn-secondary">
              戻る
            </Link>
          </div>
        </div>
      </MainContentLayout>
    </DefaultLayout>
  );
}

export default CustomersUndergoingTreatment;
